// extracted by mini-css-extract-plugin
export default {"thirdPartyBtnWrapper":"s7-z"};